export const ar = {
  globals: {},
  auth: {
    emailId: " البريد الإلكتروني",
    password: "كلمة المرور",
    remember: "تذكرني",
    forgotPassword: "نسيت كلمة المرور",
    oldPass: "كلمة المرور القديمة",
    confmPas: "تأكيد كلمة المرور",
    otpVerification: "التحقق من OTP",
    verify: "تحقق",
    resendOtp: "إعادة إرسال OTP",
    login: "تسجيل الدخول",
    resendPass: "إعادة تعيين كلمة المرور",
    editProfile: "تعديل الملف الشخصي",
    firstName: "الاسم الأول",
    lastName: "اسم العائلة",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    dontHave: "ليس لديك حساب؟",
    signUp: "سجل الآن",
    already: "هل لديك حساب بالفعل؟",
    enterOtp: "أدخل OTP",
    otpSentTo: "تم إرسال رمز OTP مكون من 4 أرقام إلى",
    codeExpire: "الرمز سينتهي صلاحيته خلال",
    logout: "هل أنت متأكد أنك تريد تسجيل الخروج؟",
  },

  main: {
    productNameEn: "اسم المنتج (الإنجليزية)",
    productNameAr: "اسم المنتج (العربية)",
    productNameRu: "اسم المنتج (الروسية)",
    gradeEn: "الدرجة (الإنجليزية)",
    gradeAr: "الدرجة (العربية)",
    gradeRu: "الدرجة (الروسية)",
    modelEn: "رقم الموديل (الإنجليزية)",
    modelAr: "رقم الموديل (العربية)",
    modelRu: "رقم الموديل (الروسية)",
    images: "الصور",
    editProduct: "تعديل المنتج",
    addProduct: "إضافة منتج",
    deliveryInformation: "معلومات التوصيل",
    instructions: "التعليمات",
    orderSummary: "ملخص الطلب",
    orderItems: "عناصر الطلب",
    total: "الإجمالي",
    item: "عنصر",
    orderDetails: "تفاصيل الطلب",
    productDesc: "وصف المنتج",
    productType: "نوع المنتج",
    shelfLife: "مدة الصلاحية",
    modalNumber: "رقم الموديل",
    grade: "الدرجة",
    placeOfOrigin: "مكان المنشأ",
    quantity: "الكمية",
    back: "رجوع",
    productDetails: "تفاصيل المنتج",
    list: "القائمة",
    addFaq: "إضافة سؤال شائع",
    answer: "الإجابة",
    question: "السؤال",
    arabic: "العربية",
    english: "الإنجليزية",
    russian: "الروسية",
    selectLang: "اختر اللغة",
    generalSettings: "الإعدادات العامة",
    faqs: "الأسئلة الشائعة",
    query: "استفسار",
    revertToQuery: "العودة إلى الاستفسار",
    averageDeliveryTime: "متوسط وقت التوصيل (بالأيام)",
    responseTime: "وقت الاستجابة (بالساعات)",
    helpAndSupport: "المساعدة والدعم",
    profileInfo: "معلومات الملف الشخصي",
    broadcast: "البث",
    select: "اختيار",
    notificationType: "نوع الإشعار",
    sendNotification: "إرسال إشعار",
    addNotification: "إضافة إشعار",
    notificationTable: "جدول الإشعارات",
    averageFeedback: "متوسط التعليقات",
    repeatCustomers: "العملاء المتكررون",
    respond: "الرد",
    review: "مراجعة",
    customer: "العميل",
    ratings: "التقييمات والمراجعات",
    typeMessage: "اكتب رسالتك...",
    percentage: "النسبة المئوية",
    addDiscount: "إضافة خصم",
    discountTable: "جدول الخصومات",
    amount: "المبلغ",
    orderNumber: "رقم الطلب",
    withdraw: "سحب المدفوعات",
    paymentHistory: "سجل المدفوعات",
    extraPaymentByUser: "دفعة إضافية من المستخدم",
    setRefund: "تحديد المبلغ المسترد",
    setRefundAmount: "تحديد مبلغ الاسترداد",
    exchange: "استبدال",
    return: "إرجاع",
    returnTable: "جدول الإرجاع والاستبدال",
    quotesTable: "جدول العروض",
    cancelled: "ملغى",
    selectDateRange: "اختر نطاق التاريخ",
    ordersTable: "جدول الطلبات",
    send: "إرسال",
    selectProduct: "اختر المنتج",
    timeFrame: "الإطار الزمني (بالساعات)",
    sendQuotation: "إرسال عرض السعر",
    accepted: "تم القبول",
    addProducts: "إضافة منتجات",
    availableStock: "المخزون المتوفر",
    quantityPerUnit: "الكمية لكل وحدة",
    pricePerUnit: "السعر لكل وحدة",
    productsTable: "جدول المنتجات",
    rating: "التقييم",
    quantitySold: "الكمية المباعة",
    products: "المنتجات",
    bestSelling: "أفضل المنتجات مبيعًا",
    commissionPaid: "العمولة المدفوعة",
    revenue: "الإيرادات",
    newOrders: "طلبات جديدة",
    pendingQuotes: "عروض الأسعار المعلقة",
    monthlySales: "المبيعات الشهرية",
    totalCustomers: "إجمالي العملاء",
    totalVendors: "إجمالي البائعين",
    totalOrders: "الطلبات الجارية",
    completedOrders: "الطلبات المكتملة",
    cancelledOrders: "الطلبات الملغاة",
    totalCategories: "إجمالي الفئات",
    totalSubCategories: "إجمالي الفئات الفرعية",
    totalRevenue: "إجمالي الإيرادات",
    totalProductsListed: "إجمالي المنتجات المدرجة",
    exportCsv: "تصدير CSV",
    sNo: "رقم",
    image: "صورة",
    fullName: "الاسم الكامل",
    phoneNumber: "رقم الهاتف",
    email: "البريد الإلكتروني",
    businessName: "اسم النشاط التجاري",
    industryType: "نوع الصناعة",
    address: "العنوان",
    manageAccount: "إدارة الحساب",
    reject: "رفض",
    accept: "قبول",
    pending: "قيد الانتظار",
    approved: "تمت الموافقة",
    rejected: "مرفوض",
    deactivate: "تم التعطيل",
    search: "ابحث هنا",
    accountStatus: "حالة الحساب",
    actions: "الإجراءات",
    name: "الاسم",
    subCategory: "الفئة الفرعية",
    addCategory: "إضافة فئة",
    viewSubCategories: "عرض الفئات الفرعية",
    selectCategory: "اختر فئة",
    selectSubCategory: "اختر فئة فرعية",
    clearFilter: "مسح الفلتر",
    addProduct: "إضافة منتج",
    productName: "اسم المنتج",
    vendorName: "اسم البائع",
    subCategoryName: "اسم الفئة الفرعية",
    parentCategory: "الفئة الرئيسية",
    manageProduct: "إدارة المنتج",
    status: "الحالة",
    todayDeals: "عروض اليوم",
    bestDeals: "أفضل العروض",
    customerName: "اسم العميل",
    inProgress: "قيد التنفيذ",
    category: "الفئة",
    productQuantity: "كمية المنتج",
    price: "السعر",
    specificReq: "متطلبات خاصة",
    chat: "دردشة",
    quoteStatus: "حالة العرض",
    sendQuote: "إرسال عرض",
    deliveryConditions: "شروط التوصيل",
    shippingCharge: "رسوم الشحن",
    freeDelivery: "توصيل مجاني",
    payment: "الدفع",
    refundable: "قابل للاسترداد",
    nonRefundable: "غير قابل للاسترداد",
    update: "تحديث",
    cancel: "إلغاء",
    orderId: "معرف الطلب",
    date: "التاريخ",
    refundAmount: "مبلغ الاسترداد",
    amountSetByVendor: "المبلغ المحدد من قبل البائع",
    refund: "استرداد",
    refundPayment: "دفع الاسترداد",
    addBanner: "إضافة بانر",
    banner: "بانر",
    discountName: "اسم الخصم",
    discountPercentage: "نسبة الخصم",
    description: "الوصف",
    type: "النوع",
    bannerType: "نوع البانر",
    startDate: "تاريخ البدء",
    endDate: "تاريخ الانتهاء",
    addDiscount: "إضافة خصم",
    onGoing: "جارٍ التنفيذ",
    completed: "مكتمل",
    orderTrackId: "معرف تتبع الطلب",
    userName: "اسم المستخدم",
    subTotal: "الإجمالي الفرعي",
    totalCost: "التكلفة الإجمالية",
    deliveryFees: "رسوم التوصيل",
    shippingAddress: "عنوان الشحن",
    contact: "جهة الاتصال",
    orderStatus: "حالة الطلب",
    paymentStatus: "حالة الدفع",
    orderPlaced: "تم تقديم الطلب",
    shipping: "الشحن",
    delivered: "تم التوصيل",
    extraAmountPay: "مبلغ إضافي للدفع",
    totalCostPay: "إجمالي التكلفة للدفع",
    acceptReject: "قبول / رفض",
    inbox: "صندوق الوارد",
    totalPayments: "إجمالي المدفوعات",
    pendingPayments: "المدفوعات المعلقة",
    amountPaidToVendor: "المبلغ المدفوع للبائع",
    makePayment: "إجراء الدفع",
    pay: "دفع",
    addNotification: "إضافة إشعار",
    sentTo: "أُرسل إلى",
    title: "العنوان",
    messages: "الرسائل",
    delete: "حذف",
    addSubAdmin: "إضافة مشرف فرعي",
    role: "الدور",
    add: "إضافة",
    platformCommission: "عمولة المنصة",
    tax: "الضريبة",
    responseTime: "وقت الاستجابة (بالساعات)",
    avgDeliveryTime: "متوسط وقت التوصيل (بالأيام)",
    save: "حفظ",
    orderCancellationTime: "وقت إلغاء الطلب (بالساعات)",
    orderExchangeTime: "وقت استبدال الطلب (بالأيام)",
    serviceFee: "رسوم الخدمة",
    general: "عام",
    timing: "التوقيت",
    contactSupport: "اتصل بالدعم",
    privacyPolicy: "سياسة الخصوصية",
    agreement: "الاتفاقية",
    terms: "الشروط والأحكام",
    cookiesPolicy: "سياسة الكوكيز",
    about: "معلومات عنا",
    dataDeletion: "سياسة حذف البيانات",
    conversionRate: "معدل التحويل",
    conversionUsdToAed: "معدل التحويل من الدولار الأمريكي إلى الدرهم الإماراتي",
    shelfEn: "مدة الصلاحية (الإنجليزية)",
    shelfAr: "مدة الصلاحية (العربية)",
    shelfRu: "مدة الصلاحية (الروسية)",
    styleEn: "الأسلوب (الإنجليزية)",
    styleAr: "الأسلوب (العربية)",
    styleRu: "النمط (بالروسية)",
    productTypeEn: "نوع المنتج (بالإنجليزية)",
    producTypeAr: "نوع المنتج (بالعربية)",
    productTypeRu: "نوع المنتج (بالروسية)",
    placeOfOrigin: "بلد المنشأ",
    stock: "الكمية المتوفرة",
    priceUnit: "وحدة السعر",
    select: "اختر",
    makeAsPackage: "جعله كحزمة",
    quantityPerUnit: "الكمية لكل وحدة",
    pricePerUnit: "السعر لكل وحدة",
    minPerchaseQty: "الحد الأدنى للشراء (بالوحدة)",
    descEng: "الوصف (بالإنجليزية)",
    descAr: "الوصف (بالعربية)",
    descRu: "الوصف (بالروسية)",
    bulkPricing: "تسعير الجملة",
    minQty: "الحد الأدنى للكمية",
    maxQty: "الحد الأقصى للكمية",
    remove: "إزالة",
    addBulk: "إضافة تسعير الجملة",
    pricePerKg: "السعر لكل كيلوجرام",
    pricePerLiter: "السعر لكل لتر",
    minQtyKg: "الحد الأدنى للشراء (بالكيلوجرام)",
    minQtyLiter: "الحد الأدنى للشراء (باللتر)",
    selectDateRange: "اختر نطاق التاريخ",
    quotedSubmitted: "تم تقديم العرض",
    quoteNotSubmitted: "لم يتم تقديم العرض",
    editBanner: "تعديل البانر",
    createBannerFor: "إنشاء بانر لـ",
    discountNameEn: "اسم الخصم باللغة الإنجليزية",
    discountNameAr: "اسم الخصم باللغة العربية",
    discountNameRu: "اسم الخصم باللغة الروسية",
    discountPer: "نسبة الخصم",
    addBannerImage: "إضافة صورة البانر",
    orderDetails: "تفاصيل الطلب",
    customerDetails: "تفاصيل العميل",
    productsOrdered: "المنتجات المطلوبة",
    regNo: "الرقم المسجل",
    orderedQty: "الكمية المطلوبة",
    myProfile: "ملفي الشخصي",
    changePassword: "تغيير كلمة المرور",
    logout: "تسجيل الخروج",
    currentPass: "كلمة المرور الحالية",
    newPassword: "كلمة المرور الجديدة",
    confirmPass: "تأكيد كلمة المرور",
    daily: "يومي",
    weekly: "أسبوعي",
    monthly: "شهري",
    yearly: "سنوي",
    orders: "الطلبات",
    sales: "المبيعات",
    overView: "نظرة عامة",
    signToSura: "تسجيل الدخول إلى Sura Trade",
    createAccount: "إنشاء حساب",
    agree: "أوافق على اتفاقية Sura Trade",
    profileSetup: "إعداد الملف الشخصي",
    pinCode: "الرمز البريدي",
    city: "المدينة",
    phoneOpt: "رقم الهاتف (اختياري)",
    bankDetails: "تفاصيل البنك",
    bankName: "اسم البنك",
    bankBranch: "فرع البنك",
    holder: "اسم صاحب الحساب",
    accNumber: "رقم الحساب",
    swift: "رمز السويفت",
    passSetup: "إعداد كلمة المرور",
    enterPass: "أدخل كلمة المرور",
    reEnterPAss: "أعد إدخال كلمة المرور",
    businessReq: "تسجيل الأعمال",
    confirmNewPass: "تأكيد كلمة المرور الجديدة",
    submit: "إرسال",
    productAdded: "تمت إضافة المنتج بنجاح",
    productUpdated: "تم تحديث المنتج بنجاح",
    aggrement: "اتفاقية سُرى التجارية",
    retailer: "تاجر تجزئة",
    wholeSaler: "تاجر جملة",
    distributor: "موزع",
    yes: "نعم",
    no: "لا",
    checkNewMessage: "تحقق من الرسائل الجديدة",
    product: "المنتج",
    discountUpdated: "تم تحديث الخصم بنجاح",
    discountAdded: "تمت إضافة الخصم بنجاح",
    editDiscount: "تعديل الخصم",
    discountNameEn: "اسم الخصم (بالإنجليزية)",
    discountNameAr: "اسم الخصم (بالعربية)",
    discountNameRu: "اسم الخصم (بالروسية)",
    descEng: "الوصف (بالإنجليزية)",
    descAr: "الوصف (بالعربية)",
    descRu: "الوصف (بالروسية)",
    startTime: "وقت البدء",
    endTime: "وقت الانتهاء",
    cmsUpdated: "تم تحديث نظام إدارة المحتوى بنجاح",
    aboutUs: "من نحن",
    terms: "الشروط والأحكام",
    privacy: "سياسة الخصوصية",
    profileCreated:
      "تم إنشاء الملف الشخصي بنجاح! يرجى الانتظار حتى يوافق المسؤول على ملفك الشخصي",
    profileUpdate: "تم تحديث الملف الشخصي بنجاح",
    downloadPdf: "انقر لتنزيل ملف PDF",
  },
  dashboard: {},

  error: {
    required: "هذا الحقل مطلوب",
    validation1: "الرجاء اختيار فيديو صالح",
    maxValidation: "الحد الأقصى المسموح به 80 حرفًا",
    minValidation: "الحد الأدنى المطلوب 3 أحرف",
    noData: "لم يتم العثور على نتائج",
    titlereq: "العنوان مطلوب",
    descReq: "الوصف مطلوب",
    noFaq: "لم يتم العثور على قائمة الأسئلة الشائعة",
    emailReq: "البريد الإلكتروني مطلوب!",
    validEmail: "أدخل عنوان بريد إلكتروني صالح!",
    firstReq: "الاسم الأول مطلوب",
    lastReq: "اسم العائلة مطلوب",
    phoneReq: "رقم الهاتف مطلوب",
    minPhone: "يجب أن يكون رقم الهاتف 6 أرقام على الأقل",
    maxPhone: "يجب أن يكون رقم الهاتف 16 رقمًا كحد أقصى",
    subAdminCreated: "تم إنشاء المسؤول الفرعي بنجاح",
    subAdminUpdate: "تم تحديث المسؤول الفرعي بنجاح",
    userUpdate: "تم تحديث المستخدم بنجاح",
    statusUpdate: "تم تحديث الحالة بنجاح",
    subAdminDel: "تم حذف المسؤول الفرعي بنجاح",
    userDel: "تم حذف المستخدم بنجاح",
    max100: "الحد الأقصى المسموح به 100 حرف",
    max250: "الحد الأقصى المسموح به 250 حرفًا",
    max500: "الحد الأقصى المسموح به 500 حرف",
    catAdd: "تم إضافة الفئة بنجاح",
    catUpdate: "تم تحديث الفئة بنجاح",
    settingUpdate: "تم تحديث الإعدادات بنجاح",
    faqAdd: "تم إضافة الأسئلة الشائعة بنجاح",
    faqDel: "تم حذف الأسئلة الشائعة بنجاح",
    cmsUpdate: "تم تحديث CMS بنجاح",
    messageReq: "الرسالة مطلوبة",
    notiAdd: "تم إضافة الإشعار بنجاح",
    notiDel: "تم حذف الإشعار بنجاح",
    logutReq: "هل أنت متأكد من أنك تريد تسجيل الخروج؟",
    noUserFound: "لم يتم العثور على مستخدم",
    noVendorFound: "لم يتم العثور على بائع",
    noSubFound: "لم يتم العثور على فئة فرعية",
    noChatFound: "لم يتم العثور على محادثات",
    categoryReq: "الفئة مطلوبة",
    subCategoryReq: "الفئة الفرعية مطلوبة",
    passReq: "كلمة المرور مطلوبة",
    passValid:
      "يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل، وحرف كبير، وحرف صغير، ورقم، ورمز خاص.",
    passMatch: "يجب أن تتطابق كلمتا المرور.",
    min6: "الحد الأدنى 6 أحرف مطلوب",
    passNotMatch: "كلمة المرور غير متطابقة",
    confirmPassReq: "تأكيد كلمة المرور مطلوب",
    agreeTo: "يرجى الموافقة على الاتفاقية أولاً",
    uploadImage: "يرجى تحميل الصور",
    docReq: "المستندات مطلوبة",
    areYouSure: "هل أنت متأكد من حذف هذا؟",
    uploadBanner: "يرجى تحميل صورة للإعلان",
    addSettings: "يرجى إضافة الإعدادات العامة أولاً",
  },
  messages: {},
};
